import React from 'react';

import './Footer.css';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';

const Footer = () => {
  const navigate = useNavigate();
  return (
    <>
      <footer>
        <div className="homepage_footer_up">
          <div className="homepage_footerdiv1">
            <img src={logo} alt="logo" loading="lazy" />
          </div>
          <div className="homepage_footerdiv2">
            <p className="homepage_footer_heading">Quick Links</p>
            <ul className="homepage_footer_link">
              <li>
                <Link to="/About-Us" className="homepage_footer_info ">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/HowitWorks" className="homepage_footer_info ">
                  How it Works
                </Link>
              </li>
              {/* <li>
                <Link to="/" className="homepage_footer_info ">
                  Various versions
                </Link>
              </li>
              <li>
                <Link to="/" className="homepage_footer_info ">
                  New Features
                </Link>
              </li> */}
            </ul>
          </div>
          <div className="homepage_footerdiv3">
            <p className="homepage_footer_heading">Support</p>
            <ul className="homepage_footer_link">
              <li>
                <Link to="/Contact-Us" className="homepage_footer_info ">
                  Contact Us
                </Link>
              </li>
              {/* <li>
                <Link to="/" className="homepage_footer_info ">
                  Support Lorem Ipsum
                </Link>
              </li>
              <li>
                <Link to="/" className="homepage_footer_info ">
                  Lorem Ipsum
                </Link>
              </li>               <li>
                <Link to="/" className="homepage_footer_info ">
                  Careers
                </Link>
              </li>*/}
            </ul>
          </div>
          <div className="homepage_footerdiv4">
            <p className="homepage_footer_heading">Social</p>
            <div className="homepage_footer_socialbtn">
              <a
                aria-label="facebook"
                href="https://www.facebook.com/people/i-Companion-Care/61558466857494/?sfnsn=wa&mibextid=RUbZ1f"
                target="_blank"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="37"
                  height="37"
                  viewBox="0 0 47 47"
                  fill="none"
                  style={{ marginRight: '7px' }}
                  // onClick={() => naviagte("/")}
                >
                  <circle cx="23.5" cy="23.5" r="22" fill="var(--footersocial)" />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    x="25%"
                    y="25%"
                  >
                    <g clipPath="url(#clip0_30_917)">
                      <path
                        d="M14 13.5H16.5L17.5 9.5H14V7.5C14 6.47 14 5.5 16 5.5H17.5V2.14C17.174 2.097 15.943 2 14.643 2C11.928 2 10 3.657 10 6.7V9.5H7V13.5H10V22H14V13.5Z"
                        fill="var(--white)"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_30_917">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </svg>
              </a>
              <a aria-label="instagram" href="https://www.instagram.com/icompanion_bayarea/" target="_blank">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="37"
                  height="37"
                  viewBox="0 0 47 47"
                  fill="none"
                  style={{ marginRight: '7px' }}
                >
                  <circle cx="23.5" cy="23.5" r="22" fill="var(--footersocial)" />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    x="25%"
                    y="25%"
                  >
                    <path
                      d="M13.0281 2.00098C14.1535 2.00284 14.7238 2.00879 15.2166 2.02346L15.4107 2.02981C15.6349 2.03778 15.8561 2.04778 16.1228 2.06028C17.1869 2.10944 17.9128 2.27778 18.5503 2.52528C19.2094 2.77944 19.7661 3.12278 20.3219 3.67861C20.8769 4.23444 21.2203 4.79278 21.4753 5.45028C21.7219 6.08694 21.8903 6.81361 21.9403 7.87778C21.9522 8.14444 21.9618 8.36564 21.9697 8.58989L21.976 8.78397C21.9906 9.27672 21.9973 9.8471 21.9994 10.9725L22.0002 11.7182C22.0003 11.8093 22.0003 11.9033 22.0003 12.0003L22.0002 12.2824L21.9996 13.0281C21.9977 14.1535 21.9918 14.7238 21.9771 15.2166L21.9707 15.4107C21.9628 15.6349 21.9528 15.8561 21.9403 16.1228C21.8911 17.1869 21.7219 17.9128 21.4753 18.5503C21.2211 19.2094 20.8769 19.7661 20.3219 20.3219C19.7661 20.8769 19.2069 21.2203 18.5503 21.4753C17.9128 21.7219 17.1869 21.8903 16.1228 21.9403C15.8561 21.9522 15.6349 21.9618 15.4107 21.9697L15.2166 21.976C14.7238 21.9906 14.1535 21.9973 13.0281 21.9994L12.2824 22.0002C12.1913 22.0003 12.0973 22.0003 12.0003 22.0003L11.7182 22.0002L10.9725 21.9996C9.8471 21.9977 9.27672 21.9918 8.78397 21.9771L8.58989 21.9707C8.36564 21.9628 8.14444 21.9528 7.87778 21.9403C6.81361 21.8911 6.08861 21.7219 5.45028 21.4753C4.79194 21.2211 4.23444 20.8769 3.67861 20.3219C3.12278 19.7661 2.78028 19.2069 2.52528 18.5503C2.27778 17.9128 2.11028 17.1869 2.06028 16.1228C2.0484 15.8561 2.03871 15.6349 2.03086 15.4107L2.02457 15.2166C2.00994 14.7238 2.00327 14.1535 2.00111 13.0281L2.00098 10.9725C2.00284 9.8471 2.00879 9.27672 2.02346 8.78397L2.02981 8.58989C2.03778 8.36564 2.04778 8.14444 2.06028 7.87778C2.10944 6.81278 2.27778 6.08778 2.52528 5.45028C2.77944 4.79194 3.12278 4.23444 3.67861 3.67861C4.23444 3.12278 4.79278 2.78028 5.45028 2.52528C6.08778 2.27778 6.81278 2.11028 7.87778 2.06028C8.14444 2.0484 8.36564 2.03871 8.58989 2.03086L8.78397 2.02457C9.27672 2.00994 9.8471 2.00327 10.9725 2.00111L13.0281 2.00098ZM12.0003 7.00028C9.23738 7.00028 7.00028 9.23981 7.00028 12.0003C7.00028 14.7632 9.23981 17.0003 12.0003 17.0003C14.7632 17.0003 17.0003 14.7607 17.0003 12.0003C17.0003 9.23738 14.7607 7.00028 12.0003 7.00028ZM12.0003 9.00028C13.6572 9.00028 15.0003 10.3429 15.0003 12.0003C15.0003 13.6572 13.6576 15.0003 12.0003 15.0003C10.3434 15.0003 9.00028 13.6576 9.00028 12.0003C9.00028 10.3434 10.3429 9.00028 12.0003 9.00028ZM17.2503 5.50028C16.561 5.50028 16.0003 6.06018 16.0003 6.74943C16.0003 7.43867 16.5602 7.99944 17.2503 7.99944C17.9395 7.99944 18.5003 7.43954 18.5003 6.74943C18.5003 6.06018 17.9386 5.49941 17.2503 5.50028Z"
                      fill="var(--white)"
                    />
                  </svg>
                </svg>
              </a>
              <a aria-label="twitter" href="https://twitter.com/icompanioncare" target="_blank">
                <svg
                  width="35"
                  height="35"
                  viewBox="0 0 45 45"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ marginRight: '7px' }}
                >
                  <circle cx="22.5" cy="22.5" r="22.5" fill="#42382E" />
                  <path
                    d="M29.2048 13.25H32.5128L25.2858 21.51L33.7878 32.75H27.1308L21.9168 25.933L15.9508 32.75H12.6408L20.3708 23.915L12.2148 13.25H19.0408L23.7538 19.481L29.2048 13.25ZM28.0438 30.77H29.8768L18.0448 15.126H16.0778L28.0438 30.77Z"
                    fill="white"
                  />
                </svg>
              </a>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="37"
                height="37"
                viewBox="0 0 47 47"
                fill="none"
                style={{ marginRight: '7px' }}
              >
                <circle cx="50%" cy="50%" r="22" fill="var(--footersocial)" />

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="var(--white)"
                  x="25%"
                  y="25%"
                >
                  <g clipPath="url(#clip0_30_920)">
                    <path
                      d="M6.93994 5.00002C6.93968 5.53046 6.72871 6.03906 6.35345 6.41394C5.97819 6.78883 5.46937 6.99929 4.93894 6.99902C4.40851 6.99876 3.89991 6.78779 3.52502 6.41253C3.15014 6.03727 2.93968 5.52846 2.93994 4.99802C2.94021 4.46759 3.15117 3.95899 3.52644 3.5841C3.9017 3.20922 4.41051 2.99876 4.94094 2.99902C5.47137 2.99929 5.97998 3.21026 6.35486 3.58552C6.72975 3.96078 6.94021 4.46959 6.93994 5.00002ZM6.99994 8.48002H2.99994V21H6.99994V8.48002ZM13.3199 8.48002H9.33994V21H13.2799V14.43C13.2799 10.77 18.0499 10.43 18.0499 14.43V21H21.9999V13.07C21.9999 6.90002 14.9399 7.13002 13.2799 10.16L13.3199 8.48002Z"
                      fill="var(--white)"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_30_920">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </svg>
            </div>
          </div>
        </div>
        <div className="homepage_footer_down">
          <hr />
          <p className="homepage_footer_info2">
            <Link to="/Terms">Terms</Link> <Link to="/Privacy">Privacy</Link>© Copyright 2024. All Rights Reserved.
          </p>
        </div>
      </footer>
    </>
  );
};
export default Footer;
